<template>
  <div class="lease-management-container">
    <!-- 新增：年度费用统计卡片 -->
    <el-row :gutter="20" style="margin-bottom: 20px">
      <el-col :span="8">
        <el-card class="stat-card total-card" shadow="hover">
          <div class="stat-content">
            <p class="stat-label">本年度应收总额</p>
            <p class="stat-num red">{{ totalReceivable }} 元</p>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="stat-card total-card" shadow="hover">
          <div class="stat-content">
            <p class="stat-label">本年度已缴总额</p>
            <p class="stat-num green">{{ totalPaid }} 元</p>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="stat-card total-card" shadow="hover">
          <div class="stat-content">
            <p class="stat-label">本年度欠费总额</p>
            <p class="stat-num orange">{{ totalOutstanding }} 元</p>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-card class="search-card" shadow="never">
      <el-form :model="queryParams" :inline="true" class="search-form">
        <el-form-item label="区域：">
          <el-select 
            v-model="queryParams.area" 
            placeholder="请选择区域"
            clearable
            style="width: 120px"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="南区" value="南区"></el-option>
            <el-option label="北区" value="北区"></el-option>
          </el-select>
        </el-form-item>

        
        <el-form-item label="年度：">
          <el-select
            v-model="queryParams.annual"
            placeholder="选择年度"
            clearable
            style="width: 100px"
          >
            <el-option label="全部" value=""></el-option>
            <el-option :label="year" :value="year" v-for="year in yearList" :key="year"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="承租人：">
          <el-input
            v-model="queryParams.lessee"
            placeholder="请输入承租人"
            clearable
            style="width: 180px"
          />
        </el-form-item>
        
        <el-form-item label="联系人：">
          <el-input
            v-model="queryParams.contactPerson"
            placeholder="请输入联系人"
            clearable
            style="width: 110px"
          />
        </el-form-item>

        <el-form-item label="缴费方式：">
          <el-select 
            v-model="queryParams.propertyFeePayType" 
            placeholder="请选择缴费方式"
            clearable
            style="width: 130px"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="按月缴费" value="按月缴费"></el-option>
            <el-option label="按季度缴费" value="按季度缴费"></el-option>
            <el-option label="按半年度缴费" value="按半年度缴费"></el-option>
            <el-option label="按年缴费" value="按年缴费"></el-option>
            <el-option label="一次性付清" value="一次性付清"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">
            搜索
          </el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">
            重置
          </el-button>
          <el-button 
            type="success" 
            icon="el-icon-plus" 
            @click="handleAdd"
            class="btn-add"
          >
            新增物业费信息
          </el-button>
          <el-button 
            type="warning" 
            icon="el-icon-bell" 
            @click="handleWarningFilter"
            class="btn-warning"
          >
            物业费到期预警(10天)
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="table-card" shadow="never">
      <div class="table-header">
        <div class="table-title">
          <i class="el-icon-user"></i>
          淮北科创中心物业费信息管理
        </div>
        <div class="table-actions">
          <el-input
            v-model="quickSearch"
            placeholder="快速搜索（承租人/联系人/联系方式）..."
            prefix-icon="el-icon-search"
            style="width: 280px; margin-right: 10px;"
            size="small"
            clearable
            @input="handleQuickSearch"
          />
        </div>
      </div>
      
      <el-table
        ref="leaseTable"
        v-loading="loading"
        :data="tableData"
        border
        stripe
        style="width: 100%"
        :height="tableHeight"
        :row-class-name="tableRowClassName"
      >
        <el-table-column 
          label="序号" 
          width="70"
          align="center"
        >
          <template slot-scope="scope">
            <span class="serial-number">
              {{ (pageIndex - 1) * pageSize + scope.$index + 1 }}
            </span>
          </template>
        </el-table-column>
        <el-table-column 
          prop="annual" 
          label="年度" 
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag type="info" size="small" effect="plain">{{ scope.row.annual || '-' }}</el-tag>
          </template>
        </el-table-column>

        
        <el-table-column 
          prop="area" 
          label="区域" 
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag size="small" type="primary" effect="plain">
              {{ scope.row.area || '-' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column 
          prop="buildingNo" 
          label="楼栋号" 
          width="80"
          align="center"
        />
        
        <el-table-column 
          prop="roomNo" 
          label="房间号" 
          width="80"
          align="center"
        />

        
        <el-table-column 
          prop="buildingArea" 
          label="建筑面积(㎡)" 
          width="110"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.buildingArea || 0 }}
          </template>
        </el-table-column>

        <el-table-column 
          prop="lessee" 
          label="承租人" 
          min-width="120"
          show-overflow-tooltip
        />

        <el-table-column 
          prop="leaseStartTime" 
          label="开始时间" 
          width="120"
          align="center"
        />
        
        <el-table-column 
          prop="leaseEndTime" 
          label="结束时间" 
          width="120"
          align="center"
        />

        <el-table-column 
          prop="propertyFeePayType" 
          label="缴费方式" 
          width="110"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag 
              :type="getPayTypeTagType(scope.row.propertyFeePayType)"
              size="small"
              effect="plain"
            >
              {{ scope.row.propertyFeePayType || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        
        <el-table-column 
          prop="propertyFeeUnitPrice" 
          label="单价(元/㎡)" 
          width="110"
          align="center"
        />
        
        <el-table-column 
          prop="propertyFeeAmount" 
          label="应收金额(元)" 
          width="110"
          align="center"
        >
          <template slot-scope="scope">
            <span style="color:#f56c6c;font-weight:bold">{{ scope.row.propertyFeeAmount || 0 }}</span>
          </template>
        </el-table-column>

        <el-table-column 
          prop="paidPropertyFee" 
          label="已缴金额(元)" 
          width="110"
          align="center"
        >
          <template slot-scope="scope">
            <span style="color:#67c23a;font-weight:bold">{{ scope.row.paidPropertyFee || 0 }}</span>
          </template>
        </el-table-column>

        <el-table-column 
          prop="outstandingAmount" 
          label="欠费金额(元)" 
          width="110"
          align="center"
        >
          <template slot-scope="scope">
            <span style="color:#e6a23c;font-weight:bold">{{ scope.row.outstandingAmount || 0 }}</span>
          </template>
        </el-table-column>
        
        <el-table-column 
          prop="decorationDeposit" 
          label="装修押金(元)" 
          width="110"
          align="center"
        />
        
        <el-table-column 
          prop="decorationWasteRemovalFee" 
          label="垃圾清运费(元)" 
          width="120"
          align="center"
        />
        
        <el-table-column 
          prop="contactPerson" 
          label="联系人" 
          width="100"
          align="center"
        />
        
        <el-table-column 
          prop="contactInfo" 
          label="联系方式" 
          width="130"
          align="center"
        />
        
        <el-table-column 
          prop="updateTime" 
          label="更新时间" 
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ formatDate(scope.row.updateTime) }}</span>
          </template>
        </el-table-column>
        
        <el-table-column 
          label="操作" 
          width="300" 
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <div class="action-buttons">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-view"
                @click="handleView(scope.row)"
              >
                查看
              </el-button>
              
              <el-button
                type="warning"
                size="mini"
                icon="el-icon-edit"
                @click="handleEdit(scope.row)"
              >
                编辑
              </el-button>
              
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="footer-area">
        <el-pagination
          v-if="total > 0"
          class="pagination-container"
          :current-page.sync="pageIndex"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

    <PropertyManagementFeeDialog
      :visible="dialogVisible"
      :form-data="currentFormData"
      :is-edit="isEditMode"
      @close="handleDialogClose"
      @save="handleSave"
    />
  </div>
</template>

<script>
import propertymanagementfeeApi from '../api/propertymanagementfee.js'
import PropertyManagementFeeDialog from '../components/PropertyManagementFeeDialog.vue'

export default {
  name: "propertymanagementfee",
  components: {
    PropertyManagementFeeDialog
  },
  
  data() {
    return {
      loading: false,
      originalData: [],
      tableData: [],
      filteredData: [],
      total: 0,
      quickSearch: '',
      pageIndex: 1,
      pageSize: 10,
      queryParams: {
        area: '',
        buildingNo: '',
        lessee: '',
        contactPerson: '',
        propertyFeePayType: '',
        annual: ''
      },
      dialogVisible: false,
      isEditMode: false,
      currentFormData: {},
      tableHeight: 500,
      searchTimer: null,
      warningIds: [],
      yearList: [],
      // 统计数据
      totalReceivable: 0,
      totalPaid: 0,
      totalOutstanding: 0
    }
  },
  
  mounted() {
    this.getLeaseList();
    this.tableHeight = window.innerHeight - 380;
    this.initYearList();
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  
  methods: {
    handleResize() {
      this.tableHeight = window.innerHeight - 380;
    },
    initYearList() {
      const current = new Date().getFullYear();
      for(let i = current-1; i <= current+1; i++){
        this.yearList.push(i);
      }
    },
    // 统计年度费用
    calculateYearTotal() {
      const currentYear = new Date().getFullYear();
      let receivable = 0, paid = 0, outstanding = 0;
      
      this.originalData.forEach(item => {
        if (item.annual == currentYear) {
          receivable += Number(item.propertyFeeAmount) || 0;
          paid += Number(item.paidPropertyFee) || 0;
          outstanding += Number(item.outstandingAmount) || 0;
        }
      });
      
      this.totalReceivable = receivable.toFixed(2);
      this.totalPaid = paid.toFixed(2);
      this.totalOutstanding = outstanding.toFixed(2);
    },
    getLeaseList() {
      this.loading = true;
      propertymanagementfeeApi.getAllpropertymanagementfee(this.queryParams)
        .then((response) => {
          if (response && response.data && response.data.flag === true) {
            this.originalData = response.data.data || [];
            this.filteredData = response.data.data || [];
            this.total = this.originalData.length;
            this.applyFilter();
            this.warningIds = [];
            // 统计数据
            this.calculateYearTotal();
          } else {
            this.$message.error('获取物业费信息列表失败');
            this.resetData();
          }
        }).catch((error) => {
          console.error('获取失败:', error);
          this.$message.error('加载失败');
          this.resetData();
        }).finally(() => {
          this.loading = false;
        });
    },
    resetData() {
      this.originalData = [];
      this.filteredData = [];
      this.total = 0;
      this.tableData = [];
      this.warningIds = [];
      this.totalReceivable = 0;
      this.totalPaid = 0;
      this.totalOutstanding = 0;
    },
    applyPagination() {
      const start = (this.pageIndex - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.tableData = this.filteredData.slice(start, end);
    },
    applyFilter() {
      let filtered = JSON.parse(JSON.stringify(this.originalData));
      if (this.queryParams.area) filtered = filtered.filter(i => i.area === this.queryParams.area);
      if (this.queryParams.buildingNo) filtered = filtered.filter(i => i.buildingNo === this.queryParams.buildingNo);
      if (this.queryParams.annual) filtered = filtered.filter(i => i.annual == this.queryParams.annual);
      if (this.queryParams.lessee) filtered = filtered.filter(i => i.lessee && i.lessee.includes(this.queryParams.lessee.trim()));
      if (this.queryParams.contactPerson) filtered = filtered.filter(i => i.contactPerson && i.contactPerson.includes(this.queryParams.contactPerson.trim()));
      if (this.queryParams.propertyFeePayType) filtered = filtered.filter(i => i.propertyFeePayType === this.queryParams.propertyFeePayType);
      if (this.quickSearch) {
        const s = this.quickSearch.toLowerCase();
        filtered = filtered.filter(i => 
          (i.lessee && i.lessee.toLowerCase().includes(s)) || 
          (i.contactPerson && i.contactPerson.toLowerCase().includes(s)) || 
          (i.contactInfo && i.contactInfo.toLowerCase().includes(s))
        );
      }
      this.filteredData = filtered;
      this.total = filtered.length;
      this.pageIndex = 1;
      this.applyPagination();
    },
    handleSearch() {
      this.warningIds = [];
      this.applyFilter();
    },
    handleQuickSearch() {
      if(this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.warningIds = [];
        this.applyFilter();
      }, 300);
    },
    handleReset() {
      this.queryParams = {
        area:'',
        buildingNo:'',
        lessee:'',
        contactPerson:'',
        propertyFeePayType:'',
        annual:''
      };
      this.quickSearch = '';
      this.pageIndex = 1;
      this.warningIds = [];
      this.applyFilter();
    },
    handleAdd() {
      this.currentFormData = {
        area: '',
        buildingNo: '',
        roomNo: '',
        buildingArea: 0,
        lessee: '',
        leaseStartTime: '',
        leaseEndTime: '',
        propertyFeePayDate: '',
        propertyFeePayType: '按月缴费',
        propertyFeeUnitPrice: 0,
        propertyFeeAmount: 0,
        paidPropertyFee: 0,
        outstandingAmount: 0,
        decorationDeposit: 0,
        decorationWasteRemovalFee: 0,
        contactPerson: '',
        contactInfo: '',
        remark: '',
        annual: new Date().getFullYear()
      };
      this.isEditMode = false;
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.currentFormData = JSON.parse(JSON.stringify(row));
      this.isEditMode = true;
      this.dialogVisible = true;
    },
    handleView(row) {
      this.$alert(
        `<div style="line-height:2.2">
          <p><strong>年度：</strong>${row.annual || '-'}</p>
          <p><strong>区域/楼栋/房间：</strong>${row.area || '-'}-${row.buildingNo || '-'}-${row.roomNo || '-'}</p>
          <p><strong>面积：</strong>${row.buildingArea||0} ㎡</p>
          <p><strong>单价：</strong>${row.propertyFeeUnitPrice||0} 元/㎡</p>
          <p><strong>缴费方式：</strong>${row.propertyFeePayType||'-'}</p>
          <p><strong>应收金额：</strong><span style="color:red">${row.propertyFeeAmount||0}</span> 元</p>
          <p><strong>已缴金额：</strong><span style="color:green">${row.paidPropertyFee||0}</span> 元</p>
          <p><strong>欠费金额：</strong><span style="color:orange">${row.outstandingAmount||0}</span> 元</p>
          <p><strong>承租人：</strong>${row.lessee||'-'}</p>
          <p><strong>联系人/电话：</strong>${row.contactPerson||'-'} / ${row.contactInfo||'-'}</p>
        </div>`,
        '详情',
        {
          dangerouslyUseHTMLString:true,
          confirmButtonText:'关闭'
        }
      );
    },
    handleDelete(row) {
      this.$confirm('确定删除该物业费信息？', '提示', {
        type:'warning'
      }).then(() => {
        return propertymanagementfeeApi.deletepropertymanagementfee(row.id);
      }).then(res => {
        if(res.data.flag) {
          this.$message.success('删除成功');
          this.getLeaseList();
        } else {
          this.$message.error('删除失败');
        }
      }).catch(err => {
        if (err !== 'cancel') {
          this.$message.error('删除失败');
        }
      });
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.applyPagination();
    },
    handleCurrentChange(page) {
      this.pageIndex = page;
      this.applyPagination();
    },
    handleDialogClose() {
      this.dialogVisible = false;
      this.currentFormData = {};
    },
    handleSave(formData) {
      const promise = this.isEditMode
        ? propertymanagementfeeApi.updatepropertymanagementfee(formData)
        : propertymanagementfeeApi.addpropertymanagementfee(formData);
      
      promise.then(res => {
        if (res.data.flag) {
          this.$message.success(this.isEditMode ? '更新成功' : '新增成功');
          this.dialogVisible = false;
          this.getLeaseList();
        } else {
          this.$message.error(res.data.message || '保存失败');
        }
      }).catch(() => {
        this.$message.error('保存失败');
      });
    },
    formatDate(dateStr) {
      if (!dateStr) return '-';
      try {
        return new Date(dateStr).toLocaleString('zh-CN');
      } catch (e) {
        return dateStr;
      }
    },
    getPayTypeTagType(payType) {
      const map = {
        '按月缴费': 'primary',
        '按季度缴费': 'success',
        '按半年度缴费': 'warning',
        '按年缴费': 'info',
        '一次性付清': 'danger'
      };
      return map[payType] || 'info';
    },
    handleWarningFilter() {
      this.loading = true;
      this.queryParams = {
        area: '',
        buildingNo: '',
        lessee: '',
        contactPerson: '',
        propertyFeePayType: '',
        annual: ''
      };
      this.quickSearch = '';
      this.pageIndex = 1;
      this.warningIds = [];
      
      let warningData = JSON.parse(JSON.stringify(this.originalData));
      warningData = warningData.filter(item => {
        if (item.propertyFeePayType === '一次性付清') return false;
        if (!item.propertyFeePayDate) return false;
        
        const payDate = new Date(item.propertyFeePayDate);
        if (isNaN(payDate.getTime())) return false;
        
        const cycleDays = this.calculateCycleDays(item.propertyFeePayType);
        if (cycleDays === 0) return false;
        
        const nextPayDate = new Date(payDate);
        nextPayDate.setDate(nextPayDate.getDate() + cycleDays - 1);
        
        const now = new Date();
        now.setHours(0, 0, 0, 0);
        
        const diffTime = nextPayDate - now;
        const days = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        const isWarn = days >= 0 && days <= 10;
        
        if (isWarn && item.id) {
          this.warningIds.push(item.id);
        }
        return isWarn;
      });
      
      this.filteredData = warningData;
      this.total = warningData.length;
      this.applyPagination();
      
      if (warningData.length > 0) {
        this.$message.success(`共找到 ${warningData.length} 条即将到期记录`);
      } else {
        this.$message.info('暂无即将到期记录');
      }
      this.loading = false;
    },
    calculateCycleDays(payType) {
      const map = {
        '按月缴费': 30,
        '按季度缴费': 90,
        '按半年度缴费': 180,
        '按年缴费': 365,
        '一次性付清': 0
      };
      return map[payType] || 0;
    },
    tableRowClassName({ row }) {
      if (this.warningIds.includes(row.id)) {
        return 'warning-row';
      }
      return '';
    }
  }
}
</script>

<style scoped>
.lease-management-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 84px);
}
/* 统计卡片样式 */
.stat-card {
  border-radius: 8px;
  transition: all 0.3s;
}
.stat-content {
  text-align: center;
  padding: 10px 0;
}
.stat-label {
  font-size: 14px;
  color: #666;
  margin: 0 0 8px 0;
}
.stat-num {
  font-size: 22px;
  font-weight: bold;
  margin: 0;
}
.red {
  color: #f56c6c;
}
.green {
  color: #67c23a;
}
.orange {
  color: #e6a23c;
}

.search-card {
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}
.search-form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}
.btn-add {
  background-color: #67c23a;
  border-color: #67c23a;
  color: #fff;
}
.btn-warning {
  background-color: #e6a23c;
  border-color: #e6a23c;
  color: #fff;
  margin-left: 10px;
}
.table-card {
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.table-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: center;
}
.footer-area {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}
.action-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
}
::v-deep .warning-row {
  background-color: #fff5f5 !important;
}
::v-deep .warning-row td {
  color: #f56c6c !important;
  font-weight: 600;
}
</style>